import { StatusContainer } from "./style";

interface IProps {
  width?: string;
}
export function StatusLoteReprovado({ width }: IProps) {
  return (
    <StatusContainer
      width={width}
      style={{
        backgroundColor: "#FFE4E4",
        color: "#EE5353",
        border: "1px solid #EE5353",
      }}
    >
      Reprovado
    </StatusContainer>
  );
}
